import React from "react";
import _ from "lodash";

import { withConfigContext } from "hooks/useConfig";
import { ReactComponent as LoadingIcon } from "static/images/loading.svg";
import { useBestFaresIframeHeight } from "../../hooks/useBestFaresIframeHeight";
import { useFetchRecentOrders } from "../../hooks/useFetchRecentOrders";
import { withCustomerData } from "../../hooks/useAuth";
import RecentOrder from "./RecentOrder";

import "styles/pages/favourites.scss";
import "styles/components/recent-orders.scss";

const RecentOrders = ({ apiUrl, brand, env, customerData, favouritesData }) => {
  const { favourites, favouriteLoading, toggleFavourite } = favouritesData;
  const { tickets, isLoading } = useFetchRecentOrders({
    apiUrl,
    brand,
    env,
    customerData
  });

  const { bestFaresIframeHeight } = useBestFaresIframeHeight();

  if(isLoading) {
    return (
      <div className='otrl-jp__recent-orders__loader-container'>
        <LoadingIcon />
      </div>
    );
  } else if(tickets?.length) {
    return (
      <div>
        <h2 className='otrl-jp__recent-orders__title'>Recent orders</h2>
        <div className="otrl-jp__recent-orders">
          {tickets.map((ticket, i) => (
            <RecentOrder
              order={ticket}
              favourites={favourites}
              toggleFavourite={toggleFavourite}
              loading={favouriteLoading === i}
              i={i}
            />
          ))}
        </div>
      </div>
    )
  } else {
    let src;

    const hostname = window.location.hostname;

    // local, sid or Stage
    if (hostname === 'localhost' || hostname.includes('otrldev.uk') || hostname.includes('stage.otrl.io')) {
       if (hostname.includes('map-page')) { // map-page sid box
          src = 'https://southeastern.map-page.otrldev.uk/widget/fare-finder/top-fares?id=myTopFaresWidget&url=https%3A%2F%2Fsoutheastern.stage.otrl.io%2Fwidget%2Ffare-finder%2Fdocs%2Fdemo';
       } else {
         src = 'https://southeastern.stage.otrl.io/widget/fare-finder/top-fares?id=myTopFaresWidget&url=https%3A%2F%2Fsoutheastern.stage.otrl.io%2Fwidget%2Ffare-finder%2Fdocs%2Fdemo';
       }
    } else { // prod
      src = 'https://ticket.southeasternrailway.co.uk/widget/fare-finder/top-fares?id=myTopFaresWidget&url=https%3A%2F%2Fticket.southeasternrailway.co.uk%2Fwidget%2Ffare-finder%2Fdocs%2Fdemo';
    }

    return (
      <div className="otrl-jp__best-fares">
        <iframe
          id="bestFareWidget"
          src={src}
          allow="geolocation"
          title="Best Fare Finder"
          style={{ height: `${bestFaresIframeHeight}px` }}
        />
      </div>
    )
  }
};

export default _.flow(withCustomerData, withConfigContext)(RecentOrders);
